import React from 'react';
import { Pressable, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';

type Props = {
  title: string;
  subtitle: string;
  icon?: React.ReactNode;
  active: boolean;
  onPress: () => void;
};

// Large selectable card used for the reservation-type and customer-mode
// toggles (Daily rental / Subscription, Existing / New customer).
export const OptionCard = ({
  title,
  subtitle,
  icon,
  active,
  onPress,
}: Props) => {
  const { styles } = useStyles(stylesheet);

  return (
    <Pressable
      onPress={onPress}
      style={[styles.card, active && styles.cardActive]}
    >
      <View style={styles.titleRow}>
        {icon}

        <Text type="bodyBold">{title}</Text>
      </View>

      <Text type="caption1" style={styles.subtitle}>
        {subtitle}
      </Text>
    </Pressable>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  card: {
    flex: 1,
    gap: 8,
    padding: 16,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: theme.colors.card.default.borderColor,
    backgroundColor: theme.colors.card.default.backgroundColor,
  },
  cardActive: {
    borderColor: theme.colors.buttonFilter.active.border,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  subtitle: {
    color: theme.colors.text.secondary,
  },
}));
